import { render, staticRenderFns } from "./Inicio_Estadisticas.vue?vue&type=template&id=7cfa6bcc&scoped=true"
import script from "./Inicio_Estadisticas.vue?vue&type=script&lang=js"
export * from "./Inicio_Estadisticas.vue?vue&type=script&lang=js"
import style0 from "./Inicio_Estadisticas.vue?vue&type=style&index=0&id=7cfa6bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa6bcc",
  null
  
)

export default component.exports